module.exports = {
  CLOUD_BACKUP: false,
};
